export type ReservationSource = {
  id: number
  slug: string
  name: string
  // Входит ли канал в список владельца. Не настраивал — здесь глобальный набор.
  is_selected: boolean
  // Позиция в списке владельца с нуля; null — канал в список не входит.
  position: number | null
  // Закреплённый канал: всегда первый, снять галочку нельзя.
  is_pinned: boolean
  is_external_channel: boolean
}

export type ReservationSourcesRes = ReservationSource[]

export const GET_RESERVATION_SOURCES = '/v2/pms/reservation-sources/'
